var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "spinner spinner--circle-8", style: _vm.styles },
    [
      _c("div", { staticClass: "spinner-inner", style: _vm.innerStyles }, [
        _vm._m(0)
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ball-container" }, [
      _c("div", { staticClass: "contener_mixte" }, [
        _c("div", { staticClass: "ballcolor ball_1" }, [_vm._v(" ")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contener_mixte" }, [
        _c("div", { staticClass: "ballcolor ball_2" }, [_vm._v(" ")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contener_mixte" }, [
        _c("div", { staticClass: "ballcolor ball_3" }, [_vm._v(" ")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contener_mixte" }, [
        _c("div", { staticClass: "ballcolor ball_4" }, [_vm._v(" ")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-517c2ba2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-517c2ba2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/Circle8.vue
// module id = 0VYu
// module chunks = 0